import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetDiscountById,
  UpadateDiscount,
} from "../../../store/discount-store/discount-actions";
import DiscountForm from "../../../components/Forms/DiscountForm";
import { GetConferences } from "../../../store/conferences-store/conference-actions";
import { GetCourses } from "../../../store/courses-store/course-actions";

const DiscountEdit = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const discount = useSelector((state) => state.discount.discount);
  const courses = useSelector((state) => state.course.courses);
  const conferences = useSelector((state) => state.conference.conferences);
  const auth = useSelector((state) => state.auth);
  useEffect(() => {
      if (auth.roles.includes("conferences.showAll")) {
        dispatch(GetConferences(auth.UserInfo.email, false, false));
      }
    }, [auth.UserInfo.email, auth.roles, dispatch]);
  
    useEffect(() => {
      if (auth.roles.includes("course.showAll")) {
        dispatch(GetCourses(auth.UserInfo.email, false));
      }
    }, [auth.UserInfo.email, auth.roles, dispatch]);

  useEffect(() => {
    if (discount && (discount.id === 0 || discount.id === undefined)) {
      dispatch(GetDiscountById(param.discountId, auth.UserInfo.email));
    }
  }, [param.discountId, auth.UserInfo.email, dispatch, discount]);

  return (
    <>
      <DiscountForm
        actionDiscount={UpadateDiscount}
        discount={discount}
        courses={courses}
        conferences={conferences}
      />
    </>
  );
};
export default DiscountEdit;
